import api from "./api";
import API_ROUTES from "./apiRoutes";

const videoClipService = {
  // Save a new video clip
  saveVideoClip: async (clipData) => {
    const response = await api.post(API_ROUTES.COACH.SAVE_VIDEO_CLIP, clipData);
    return response.data;
  },

  // Get all video clips with optional filters
  getVideoClips: async (params = {}) => {
    const { videoId, playerId, page = 1, limit = 20 } = params;
    const queryParams = { page, limit };
    if (videoId) queryParams.videoId = videoId;
    if (playerId) queryParams.playerId = playerId;

    const response = await api.get(API_ROUTES.COACH.GET_VIDEO_CLIPS(queryParams));
    return response.data;
  },

  // Delete a video clip
  deleteVideoClip: async (clipId) => {
    await api.delete(API_ROUTES.COACH.DELETE_VIDEO_CLIP(clipId));
    return clipId;
  },
};

export default videoClipService;
